import { useOutletContext } from "react-router-dom";
import { BarChart3 } from "lucide-react";

// Reports are part of a later phase. This page keeps the navigation structure
// in place and shows a lightweight summary based on data already available.
export default function ReportsPage() {
  const { project } = useOutletContext();
  return (
    <div data-testid="project-reports-page">
      <div className="mb-4">
        <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{project.workspace_name}</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-2">Relatórios</h1>
        <p className="text-slate-500 mt-1">Visão analítica do projeto.</p>
      </div>
      <div className="bg-white border border-dashed border-slate-300 rounded-xl p-12 text-center" data-testid="reports-placeholder">
        <BarChart3 className="w-10 h-10 text-slate-300 mx-auto" strokeWidth={1.5} />
        <h3 className="font-heading text-lg font-semibold mt-3">Relatórios em breve</h3>
        <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
          Burndown, velocidade e distribuição E/D/O/Q serão liberados em uma fase dedicada de relatórios.
        </p>
      </div>
    </div>
  );
}
